import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { AppComponent } from 'src/app/app.component';
import { FirebaseFunctionsService } from 'src/app/services/firebase-functions.service';

@Component({
  selector: 'app-jeux',
  templateUrl: './jeux.component.html',
  styleUrls: ['./jeux.component.scss']
})
export class JeuxComponent implements OnInit, OnDestroy {

  activityName: string = 'Jeux';
  activityPhotoUrl: string = '';
  isBtnCommencerActif: boolean = false;
  bgColor: string = '';
  activityId: string = '';
  choice: string = '';
  isUserClassesEmpty: boolean = true;
  minutes: string;
  minutesAuto: number = 0;
  secondesAuto: number = 0;
  isPaused = true;
  intervalCtn: any;
  userEcole: string = '';
  color: string;
  userType: any;
  userDataClasses: any[] = [];
  userClasses: Observable<unknown[]>;
  iconName: string;
  constructor(private activatedRoute: ActivatedRoute, private afs: FirebaseFunctionsService,  public app: AppComponent) {
    this.activityId = (this.activatedRoute.snapshot.params.activityId_color).split('-')[0];
    this.color = (this.activatedRoute.snapshot.params.activityId_color).split('-')[1];
    const typeUser = sessionStorage.getItem('userType');
    if (typeUser == 'administrateur') {
      this.app.navigateTo('/admin');
    }
    this.getActivityData();
  }

  ngOnInit(): void {
    this.getUserData();
    this.getUserClasses();
    this.reinitializeMenus();
    document.querySelector('.menu_activites').classList.add('selected');
    setTimeout(this.app.afficherPage, 2000);
  }
  ngOnDestroy(){
    this.stopTimer();
  }
  reinitializeMenus(){
    const menusTabs = document.querySelectorAll('.menus_tab');
    menusTabs.forEach( tabs => {
      (tabs as HTMLElement).classList.remove('selected');
    });
  }
  manageTimer(){
    const minutesP = document.querySelector('.jeux_minutes');
    const secondesP = document.querySelector('.jeux_secondes');
    this.intervalCtn = window.setInterval(() => {
            if (!this.isPaused) {
                if (this.secondesAuto === 59) {
                    this.minutesAuto++;
                    if (this.isMultipleDe15(this.minutesAuto)) {
                        this.updateMedaile(1);
                    }
                    this.secondesAuto = 0;
                }
                else {
                    this.secondesAuto++;
                }
                minutesP.innerHTML = this.minutesAuto.toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false});
                secondesP.innerHTML = this.secondesAuto.toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false});
            }
    }, 1000);
  }
  stopTimer(){
    clearInterval(this.intervalCtn);
  }
  getUserData(){
    const uid = sessionStorage.getItem('userId');
    this.afs.getUtilisateur(uid).forEach( user => {
      this.userEcole = user['ecole_id'];
      this.userType = user['typeUtilisateur'];
      this.userDataClasses = user['classes'];
    });
  }
  getActivityData(){
    this.afs.getActivityById(this.activityId).forEach( data => {
      this.activityName = data['activiteName'];
      this.afs.getImgUrlFromFireStorage(`/${data['photoUrl']}`).subscribe( img => {
        this.activityPhotoUrl = img;
      });
    });
  }
  getUserClasses(){
    const uid = sessionStorage.getItem('userId');
    this.afs.getUtilisateur(uid).forEach( user => {
      this.userType = user['typeUtilisateur'];
      if (this.userType != 'enseignant'){
        this.userClasses = this.afs.getParticipantClasses(uid);
        this.afs.getParticipantClasses(uid).forEach( data => {
          if (data.length == 0){
            this.isUserClassesEmpty = true;
          }else{
            this.isUserClassesEmpty = false;
          }
        })
      }else{
        this.userClasses = this.afs.getEnseignantClasses(uid);
        this.afs.getEnseignantClasses(uid).forEach( data => {
          if (data.length == 0){
            this.isUserClassesEmpty = true;
          }else{
            this.isUserClassesEmpty = false;
          }
        })
      }
    });
  }
  choiceChosen(event, choix: string ){
    const elmt = (event.target.tagName == 'P')? event.target.parentNode : event.target;
    const choices = document.querySelectorAll('.choice');
    choices.forEach( choice => {
      choice.classList.remove('chosen');
    });
    elmt.classList.add('chosen');
    this.choice = choix;
  }
  manageManualTimerModal(){
    const timeurModal = document.querySelector('.minuteurManuel') as HTMLElement;
    this.isBtnCommencerActif = (this.isBtnCommencerActif == true) ? false: true;
    timeurModal.style.display = (timeurModal.style.display == 'flex') ? 'none' : 'flex';
  }
  multipleOf15(min: number): number{
    return min/15;
  }
  isMultipleDe15(min): boolean {
    return ((min % 15) === 0) ? true: false;
  }
  manageChoiceModal(){
    const choiceModal = document.querySelector('.choiceModal') as HTMLElement;
    if (this.choice != ''){
      choiceModal.style.display = (choiceModal.style.display != 'flex') ? 'flex' : 'none';
      this.isBtnCommencerActif = (this.isBtnCommencerActif == true) ? false: true;
    }else{
      this.afs.showMessage(3, 'Veuiller sélectionner pour qui vous accumuler les Etoiles.', 3000);
    }
  }
  updateMedaile(num: number): void {
    const uid = sessionStorage.getItem('userId');
    if (this.choice == '1' || this.choice == '2') {
      if (this.choice == '2') {
        this.afs.updateStarsForUser(uid, num, '2', this.activityId);
      }
      else {
        this.afs.updateStarsForUser(uid, num, '1', this.activityId);
      }
    }else {
      if (this.choice !== '' && this.choice[0] == 'c') {
        this.afs.updateStarsForUser(uid, num, '3', this.activityId);
        this.afs.updateStarsForClass(uid,this.choice,num,this.activityId);
      }
    }
    this.afs.updateStarsForRegion(uid,num, this.activityId);
    this.afs.updateStarsForEcole(this.userEcole, num, this.activityId);
  }
  minuteur() {
    if(this.isBtnCommencerActif == true){
      const commencerBtn = document.querySelector('.commencer_btn') as HTMLButtonElement;
      if (commencerBtn.innerHTML === 'Commencer !') {
        commencerBtn.innerHTML = 'Pauser !';
        this.isPaused = false;
        this.manageTimer();
      }
      else {
        commencerBtn.innerHTML = 'Commencer !';
        this.isPaused = true;
        this.stopTimer();
      }
    }
  }
  getManualStars(){
    const minutesRegex =  /^[0-9]+$/;
    this.minutes = this.minutes.trim();
    if (this.minutes.match(minutesRegex) && ( parseInt(this.minutes, 10)) > 0 && parseInt(this.minutes, 10) <= 120){
      const etoiles = this.multipleOf15(parseInt(this.minutes, 10));
      this.updateMedaile(etoiles);
      this.manageManualTimerModal();
    }else{
      this.afs.showMessage(3, 'Les minutes doivent être des nombres entiers compris entre 1 et 120', 3000);
    }
  }
}
